module.exports = __webpack_public_path__ + "static/media/measure2_success.bfda9ab6.png";